import {
  Empty,
  Spin,
} from "antd";
import { useDispatch, useSelector } from "react-redux";

import ObjectForm from "components/Admin/ObjectForm";

import { updateUser } from "Redux/Admin/HmUser/action";

import { RootState } from "Redux/store";

const settings = {
  id: { hidden: true },
  password: { hidden: true },

  public_id: { label: "Public ID" },

  first_name: { editable: true, type: 'input' },
  last_name: { editable: true, type: 'input' },
  name: { editable: true, type: 'input' },

  username: { editable: true, type: 'input', rules: [{ required: true }] },
  email: { editable: true, type: 'input', rules: [{ type: 'email', required: true }] },
  phone: { editable: true, type: 'input' },

  profile_picture: { editable: true, type: 'picture' },

  is_coach: { editable: true, type: 'switch' },
  is_superuser: { editable: true, type: 'switch' },
  is_staff: { editable: true, type: 'switch' },
  is_active: { editable: true, type: 'switch' },
  verified_email: { editable: true, type: 'switch' },

  user_time_zone: { editable: true, type: 'input' },

  activation_key: { hidden: true },
  user_coach: { hidden: true },

  date_joined: { editable: false, type: 'datetime', rules: [{ type: 'object' as const }] },
  last_login: { editable: false, type: 'datetime', rules: [{ type: 'object' as const }] },
  progress_updated_at: { editable: false, type: 'datetime', rules: [{ type: 'object' as const }] },
};

const HabitsManager = () => {
  const dispatch = useDispatch();

  const { data, loading, loading_update } = useSelector(
    (state: RootState) => state.fetchDmUserReducer
  );

  const onFinish = (values: any) => {
    console.log('[onFinish]', values);

    // @ts-ignore
    if (data.id) {
      // @ts-ignore
      dispatch(updateUser(values, data.id, handleAfterUpdate));
    }
  };

  const handleAfterUpdate = () => {
    // navigate(`${ADMIN_PATH}/users`);
  };

  if (loading) {
    return <Spin tip="Loading" />;
  }

  if (!data) {
    return <Empty />
  }

  return (
    <ObjectForm
      data={data}
      settings={settings}
      loading={loading_update}
      onFinish={onFinish}
    />
  )
}

export default HabitsManager;
